import { CreditCardPaymentInfo } from '../../../revenue/shared/credit-card/credit-card-payment-info.model';
import { GatewayPaymentProfile } from '../../../revenue/shared/credit-card/card-on-file/gateway-payment-profile.model';
import { RegistrationCustomRegFieldResponse } from './registration-custom-reg-field-response.model';
import { EventPromoCode } from '../promo-codes/event-promo-code.model';
import { EventItemTotal } from './registration-event-item-total.model';
import { EventPaymentMethod } from '../payment-methods/event-payment-method.model';
import { RegistrationProfileBenefit } from './registration-profile-benefit.model';

export class RegistrationRegister {
  public EventId: number;
  public ProfileId: number;
  public DisplayName: string;
  public OrgName: string;
  public Prefix: string;
  public FName: string;
  public Mi: string;
  public LName: string;
  public Suffix: string;
  public Title: string;
  public Email: string;
  public Phone: string;
  public Ext: string;
  public Address1: string;
  public Address2: string;
  public City: string;
  public State: string;
  public Zip: string;
  public ZipExt: string;
  public Country: string;
  public OrgProfileId: number;
  public CommunicateWithProfileId: number;
  public IsMember: boolean;
  public IsRelatedToMember: boolean = false;
  public Comments: string;
  public ReminderType: string;
  public Reviewed: boolean;
  public RefNo: string;
  public CheckNum: string;
  public PO: string;
  public Comp: boolean;
  public DoNotInvoice: boolean;
  public Paid: boolean;
  public PaymentOption: number;
  public PaymentOptionForEdit: number;
  public OverridePaymentypeId: number;
  public SignUpDate: Date;
  public PaymentAmount: number;
  public CreditCardPayment: CreditCardPaymentInfo;
  public EventItemTotals: Array<EventItemTotal> = [];
  public PreTaxAmount: number;
  public PreTaxPreDiscountAmount: number = 0;
  public DiscountTotal: number = 0;
  public TaxAmount: number;
  public TotalAmount: number;
  public AdditionalPaymentAmountForEdit: number;
  public AlreadyPaidAmountForEdit: number;
  public PromoCodes: Array<EventPromoCode>;
  public EventCustomRegFieldResponses: Array<RegistrationCustomRegFieldResponse>;
  public CreateProfile: boolean;
  public ForceMemberPricing: boolean = false;
  public PaymentOptionFeeAmount: number;
  public SelectedPaymentMethod: EventPaymentMethod;
  public DoNotAddPaymentOptionFee: boolean;
  public ExistingPaymentOptionFees: number;
  public ExistingPaymentOptionFeesSet: boolean;
  // client-only (not bound by the Event API): pre-tax, post-discount total of previously invoiced non-fee item lines (edit mode)
  public PreviouslyInvoicedItemAmount: number = 0;
  // client-only: invoiced fee preserved while 'Do Not Add Payment Option Fee' zeroes ExistingPaymentOptionFees
  public InvoicedPaymentOptionFees: number = 0;
  public GatewayPaymentProfile: GatewayPaymentProfile;
  public SaveToCardOnFile: boolean;
  public OriginalInvoiceTotalAmount: number;
  public OriginalItemTotalAmount: number;
  public InvoiceTotalDelta: number;
  public OriginalTotalAmount: number;

  public PaymentMethodFeeTaxAmount: number;

  public BenefitsToApply: Array<RegistrationProfileBenefit>;
  public BenefitsPreviouslyApplied: Array<RegistrationProfileBenefit>;

  public get BenefitsToApplyTotal(): number {
    let total = 0;
    for (let ben of this.BenefitsToApply) {
      total = total + ben.ValueToApply;
    }

    return total;
  }
  public set BenefitsToApplyTotal(value: number) {
    //ignore;
  }

  public get BenefitsPreviouslyAppliedTotal(): number {
    let total = 0;
    for (let ben of this.BenefitsPreviouslyApplied) {
      total = total + ben.ValueToApply;
    }

    return total;
  }
  public set BenefitsPreviouslyAppliedTotal(value: number) {
    //ignore;
  }

  /**
   * not saved to the database
   */
  public relatedProfileId: number = 0;
  public profileOrgInd: boolean = false;

  public constructor() {
    this.EventId = 0;
    this.ProfileId = 0;
    this.DisplayName = '';
    this.OrgName = '';
    this.Prefix = '';
    this.FName = '';
    this.Mi = '';
    this.LName = '';
    this.Suffix = '';
    this.Title = '';
    this.Email = '';
    this.Phone = '';
    this.Ext = '';
    this.Address1 = '';
    this.Address2 = '';
    this.City = '';
    this.State = '';
    this.Country = '';
    this.Zip = '';
    this.ZipExt = '';
    this.OrgProfileId = 0;
    this.CommunicateWithProfileId = 0;
    this.IsMember = false;
    this.Comments = '';
    this.ReminderType = '';
    this.Reviewed = false;
    this.RefNo = '';
    this.CheckNum = '';
    this.PO = '';
    this.Comp = false;
    this.DoNotInvoice = false;
    this.Paid = false;
    this.PaymentOption = 1;
    this.SignUpDate = new Date();
    this.PaymentAmount = 0;

    this.CreditCardPayment = new CreditCardPaymentInfo();

    this.PreTaxAmount = 0;
    this.TaxAmount = 0;
    this.TotalAmount = 0;
    this.AdditionalPaymentAmountForEdit = 0;
    this.AlreadyPaidAmountForEdit = 0;
    this.PromoCodes = new Array<EventPromoCode>();
    this.EventCustomRegFieldResponses = new Array<RegistrationCustomRegFieldResponse>();

    this.CreateProfile = false;
    this.PaymentOptionFeeAmount = 0;
    this.SelectedPaymentMethod = new EventPaymentMethod();
    this.DoNotAddPaymentOptionFee = false;

    this.ExistingPaymentOptionFees = 0;
    this.ExistingPaymentOptionFeesSet = false;
    this.PreviouslyInvoicedItemAmount = 0;
    this.InvoicedPaymentOptionFees = 0;

    this.GatewayPaymentProfile = new GatewayPaymentProfile();
    this.SaveToCardOnFile = false;

    this.OriginalInvoiceTotalAmount = 0;
    this.OriginalItemTotalAmount = 0;

    this.BenefitsToApply = new Array<RegistrationProfileBenefit>();
    this.BenefitsPreviouslyApplied = new Array<RegistrationProfileBenefit>();

    this.BenefitsToApplyTotal = 0;
    this.BenefitsPreviouslyAppliedTotal = 0;

    this.InvoiceTotalDelta = 0;
  }
}
